import { api } from './api';
import { 
  ColumnAnalysisRequest,
  ColumnAnalysisResponse,
  MetadataReviewRequest,
  MetadataReviewResponse,
  UserModificationTracker 
} from '../types/columnMapping';

export const columnMappingApi = {
  analyzeColumns: async (request: ColumnAnalysisRequest) => {
    return api.post<ColumnAnalysisResponse>(
      `/column-mapping/analyze-columns`,
      request
    );
  },

  confirmMappings: async (request: MetadataReviewRequest) => {
    return api.put<MetadataReviewResponse>(
      `/column-mapping/confirm-mappings`,
      request
    );
  },

  getMetadataSuggestions: async (
    domain: string, 
    dataType?: string | null,
    column?: string | null
  ) => {
    const params = new URLSearchParams();
    // Don't add domain to params - it's already in the URL path
    if (column) params.append('column', column);
    
    const url = `/column-mapping/metadata-suggestions/${domain}${params.toString() ? '?' + params.toString() : ''}`;
    
    return api.get<Record<string, string[]>>(url);
  },

  trackUserModifications: async (request: UserModificationTracker) => {
    return api.post(
      `/column-mapping/track-user-modifications`,
      request
    );
  },

  getHistoricalHints: async (
    domain: string,
    dataType?: string | null,
    sessionId?: string | null
  ) => {
    const params = new URLSearchParams({ domain });
    if (dataType) params.append('data_type', dataType);
    if (sessionId) params.append('session_id', sessionId);
    
    return api.get(
      `/column-mapping/historical-hints?${params.toString()}`
    );
  }
};